export default __webpack_public_path__ + "static/media/banner3.1f743498.jpg";